/* eslint no-console: 0, no-underscore-dangle: 0 */
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { RelatedKeywordsStyles } from './RelatedKeywords.style';
import RelatedKeywordsPod from './RelatedKeywordsPod/RelatedKeywordsPod';

const RelatedKeywords = ({ keywords, heading, searchTerm }) => {
  useEffect(() => {
    if (keywords.length) {
      if (window._satellite) {
        window._satellite.track('Related_Keyword_Impression', `${searchTerm} | ${keywords.length}`);
      }
      const eventToDigitalData = new CustomEvent('DDXLPRelatedKeywordImpressions', {
        bubbles: true,
        detail: {
          payload: `${searchTerm} | ${keywords.length}`,
        },
      });
      window.dispatchEvent(eventToDigitalData);
    }
  }, [searchTerm]);

  if (!keywords.length) {
    return null;
  }

  return (
    <div className="related-keywords" related-keywords-impression={`${searchTerm} | ${keywords.length}`}>
      <h4 className="related-keywords-heading">{heading}</h4>
      <div className="related-keywords-scrollable-container">
        {keywords.map((keyword, index) => (
          <RelatedKeywordsPod
            keyword={keyword}
            currentKeywordPosition={index + 1}
            totalKeywords={keywords.length}
            searchTerm={searchTerm}
          />
        ))}
      </div>
      <style jsx>{RelatedKeywordsStyles}</style>
    </div>
  );
};

RelatedKeywords.propTypes = {
  keywords: PropTypes.arrayOf(PropTypes.string).isRequired,
  heading: PropTypes.string.isRequired,
  searchTerm: PropTypes.string.isRequired,
};

export { RelatedKeywords };
